var Iframe_default = {
  "iframe": "_28VwB"
};
export {
  Iframe_default as default
};
//# sourceMappingURL=Iframe-scss.js.map
